import { useEffect, useRef } from "react";

type CarbonOrmCoverProps = {
  reducedMotion: boolean;
};

export function CarbonOrmCover({ reducedMotion }: CarbonOrmCoverProps) {
  const parallaxRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const parallax = parallaxRef.current;
    if (!parallax) {
      return undefined;
    }

    const parallaxElement = parallax;
    let isMounted = true;
    let frame = 0;
    let timeout = 0;

    const runGlow = (): void => {
      function step(timestamp: number) {
        if (!isMounted) {
          return;
        }
        timestamp /= 24;
        parallaxElement.style.backgroundPosition = `${timestamp}px 38px`;
        timeout = window.setTimeout(() => {
          frame = window.requestAnimationFrame(step);
        }, 160);
      }

      frame = window.requestAnimationFrame(step);
    };

    parallaxElement.style.backgroundPosition = "0px 38px";

    if (!reducedMotion) {
      runGlow();
    }

    return () => {
      isMounted = false;
      window.cancelAnimationFrame(frame);
      window.clearTimeout(timeout);
    };
  }, [reducedMotion]);

  return (
    <figure className="legacy-cover" aria-hidden="true">
      <div
        ref={parallaxRef}
        className="legacy-cover-carbon"
        data-testid="carbonorm-cover"
        style={{ backgroundImage: 'url("/carbonorm/colorStrip.png")' }}
      >
        <div
          className="legacy-cover-carbon-molecule"
          style={{ backgroundImage: 'url("/carbonorm/Carbon-black-hollow.png")' }}
        />
      </div>
    </figure>
  );
}
